import Styled from "styled-components";

export const Question = Styled.summary`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  font-size: 1.25rem;
  line-height: 2.25rem;
  font-weight: 500;
  letter-spacing: -0.3px;
  margin: 1.25rem 0;
  cursor: pointer;

  ${(props) => props.theme.breakpoints.up("medium")} {
    font-size: 1.875rem;
  }
`;

export const Answer = Styled.div`
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-weight: 400;
  letter-spacing: -0.2px;
  margin-bottom: 1.875rem;

  ${(props) => props.theme.breakpoints.up("large")} {
    font-size: 1.624rem;
    line-height: 2rem;
  }

  & > p {
    margin: 1rem 0;
  }

  & > p:first-child {
    margin-top: 0;
  }

  & > p:last-child {
    margin-bottom: 0;
  }
`;

export const Arrow = Styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Link = Styled.a`
  text-decoration: none;
`;
